import { ProfileType } from "./ProfileType";
import { Subscription } from "../Subscription/Subcription";
import { Status } from "../Subscription/Status";
import { Lang } from "./Lang";

export const MAX_FAMILY_PROFILES = 5;

export interface User {
  email: string;
  firstName: string;
  id: string;
  lang: Lang;
  lastName: string;
  /**
   * ISO Date
   */
  birthDate?: string;
  status: string;
  betaStatus?: "active" | "inactive";
  newsletter: boolean;
  autoPassword: boolean;
  autoEmail: boolean;
  powerUser: boolean;

  partnerId?: string;
  uuid: string;
  msisdn?: string;

  anonymous?: boolean;

  passwordLastUpdatedDate: string;
  supportEmail: string;
  userProfile?: {
    needValidation: boolean;
    isValidated: boolean;
    validationUrl?: string;
  };
}

export const isKidProfile = (u: ProfileType) => {
  return u !== ProfileType.GENERIC;
};

export const userHasPlan = (u: User, subscription?: Subscription) => {
  if (u.betaStatus === "active") {
    return true;
  }
  return !!subscription && subscription!.status !== Status.INCOMPLETE;
};

export const getAisReceiptUri = (user: User) => {
  return `https://wapshop.gameloft.com/aisgamecloud/receipt.php?pid=${encodeURIComponent(
    user.partnerId as string,
  )}`;
};
